module.exports = __webpack_public_path__ + "img/1576634219.ae092421.jpg";